import _ from 'lodash';
import {propzoneLicenses} from './subscriptionCheck';

// Paid plan levels from the lowest to the highest. Monthly and yearly variants of a plan share the level.
export const PLAN_LEVELS = ['basic', 'premium', 'professional', 'enterprise'];

// UMT page that sends a subscriber to the Stripe billing portal to change the plan.
export const MANAGE_SUBSCRIPTION_URL = `${process.env.REACT_APP_ACCOUNTS_SITE}/my/subscriptions`;

/**
 * Get the highest plan level the user holds, "basic" for a logged in user without a paid plan.
 *
 * @param {*} userData
 *   User object.
 *
 * @returns {string|null}
 *   Plan level, like "premium", or NULL for an anonymous user.
 */
export const getCurrentPlanLevel = userData =>
  _.findLast(PLAN_LEVELS, level => propzoneLicenses(userData).includes(level)) || null;

/**
 * Get the label of the button that changes the current plan to another one.
 *
 * @param {string} planLevel
 *   Level of the plan in the pricing table.
 * @param {string|null} currentLevel
 *   Level of the user's current plan.
 *
 * @returns {string|null}
 *   "Upgrade", "Downgrade", or NULL for the same or an unknown level.
 */
export const getPlanChangeLabel = (planLevel, currentLevel) => {
  const planRank = PLAN_LEVELS.indexOf(planLevel);
  const currentRank = PLAN_LEVELS.indexOf(currentLevel);
  if (planRank < 0 || currentRank < 0 || planRank === currentRank) {
    return null;
  }
  return planRank > currentRank ? 'Upgrade' : 'Downgrade';
};
